import createSafeStorage from "./safeStorageCreator";
const safeLocalStorage = createSafeStorage("localStorage");
const safeSessionStorage = createSafeStorage("sessionStorage");
export { safeLocalStorage, safeSessionStorage };